module.exports = function(options)
{
    var selectBoxSelector = 'select[id$="-key"]';
    var valueFieldSelector = 'input[id$="-value"]';

    var form = this;

    form.formElement = document.querySelector(options.selectors.mainForm);


    var selectElements = form.formElement.querySelectorAll(selectBoxSelector);

    var selectElement;
    for(var i = 0; i < selectElements.length; i++)
    {   
        selectElement = selectElements[i];

        if (selectElement.selectedIndex == 0)
        {
            selectNextAvailable(selectElement, selectElements, [0]);
        }
    }

    function setAllValuesto(fields, value)
    {
        for(var i = 0; i < fields.length; i++)
        {
            fields[i].value = (typeof value === 'function' ? value(fields[i]) : value);
        }
    }

    window.setAllAnalysisMeasurementValuesTo = function(value)
    {
        setAllValuesto(form.formElement.querySelectorAll(valueFieldSelector), value)
    }        
    
    window.randomizeAllAnalysisMeasurementValues = function(min, max, decimals)
    {
        decimals = decimals === undefined ? 0 : decimals;

        setAllValuesto(form.formElement.querySelectorAll(valueFieldSelector), function(element) 
        { 
            var result = 0;
            if (element.hasAttribute('min'))
            {
                var localMin = parseFloat(element.getAttribute('min'));
                var localMax = parseFloat(element.getAttribute('max'));
                result = Math.random() * (localMax - localMin) + localMin;
            }
            else
            {
                result = Math.random() * (max - min) + min;
            }

            return result.toFixed(decimals);
        });
    }    

    return form;
}